import { useDispatch, useSelector } from "react-redux"
import { useFormikContext } from "formik"
import React, { useEffect, useState } from "react"
import { Card, CardBody } from "../../../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../../../component/atoms/RowModule/RowModule.jsx"
import { SelectInput, TextAreaInput, TextInput } from "../../../../../../../component/index.jsx"
import { getVariantAll } from "../../../../../../../redux/actions/MasterDataAction.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../../../constants/ImageConstants.js"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export const FormTreatment = ({ plantTypeId, isReadOnly, setIsValid, setFormValues, data }) => {
  const dispatch = useDispatch()
  const { values: formValues, errors, setErrors, touched } = useFormikContext()
  const { t } = useTranslation()
  const [pesticideList, setPesticideList] = useState([])

  const [countPesticide, setCountPesticide] = useState(1)
  const { General, MasterData } = useSelector((state) => state)

  useEffect(() => {
    //   edit
    if (data) {
      setCountPesticide(data?.variant_list.length)
    }
  }, [data])

  useEffect(() => {
    if (
      formValues?.treatment_name &&
      formValues?.hst_start !== "" &&
      formValues?.hst_end !== "" &&
      formValues?.description &&
      formValues?.list_pesticide?.length > 0 &&
      !errors.hasOwnProperty("list_pesticide")
    ) {
      setIsValid(false)
    } else {
      setIsValid(true)
    }
  }, [formValues, errors])

  useEffect(() => {
    dispatch(getVariantAll(plantTypeId))
  }, [plantTypeId])

  useEffect(() => {
    if (MasterData.variantList) {
      setPesticideList(
        MasterData.variantList.map((value) => ({
          label: value.name,
          value: value.id,
          isDisabled: false
        }))
      )
    }
  }, [MasterData.variantList])

  useEffect(() => {
    let newPesticideList = pesticideList
    newPesticideList.map((item) => {
      if (
        formValues["list_pesticide"].filter((value) => value?.pesticide_id === item?.value).length >
        0
      ) {
        item.isDisabled = true
      } else {
        item.isDisabled = false
      }
    })
    setPesticideList(newPesticideList)
  }, [formValues, countPesticide])

  const handleAddPesticide = () => {
    setCountPesticide(countPesticide + 1)
  }
  const handleRemovePesticide = (index) => {
    let newFormValues = formValues["list_pesticide"]
    newFormValues.splice(index, 1)
    setFormValues["list_pesticide"] = newFormValues
    setCountPesticide(countPesticide - 1)
    let newError = errors?.list_pesticide
    newError.splice(index, 1)
    setErrors(newError)
  }

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <h4 className="card-label mb-8">DETAIL TREATMENT</h4>
          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <TextInput
              editable={!isReadOnly}
              label={t("label_threatment_name")}
              required={true}
              name="treatment_name"
              placeholder={t("placeholder_input_threatment_name")}
              type={"text"}
            />
          </RowModule>

          <label className="mt-5 mb-3">
            HST <span className={"text-danger"}>*</span>
          </label>
          <RowModule customColumnCss="mb-5 col-lg-6 col-sm-6 col-md-6">
            <TextInput
              editable={!isReadOnly}
              label={t("label_from")}
              name="hst_start"
              placeholder={t("placeholder_input_first_hst")}
              type={"text"}
            />
            <TextInput
              editable={!isReadOnly}
              label={t("label_to")}
              name="hst_end"
              placeholder={t("placeholder_input_last_hst")}
              type={"text"}
            />
          </RowModule>

          <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
            <TextAreaInput
              editable={isReadOnly}
              label={t("label_description")}
              required={true}
              name="description"
              placeholder={t("placeholder_input_treatment_desc")}
              type={"text"}
            />
          </RowModule>
        </CardBody>
        <div className={"divider"} style={{ marginTop: "32px", marginBottom: "50px" }}></div>
        <CardBody className={"border-bottom-0"}>
          <h4 className="card-label mb-8">DETAIL PESTISIDA</h4>
          {[...Array(countPesticide)].map((x, i) => (
            <div
              key={i}
              className={"bg-neutral-light-gray border-neutral-medium-gray"}
              style={{
                padding: "28px 24px",
                borderRadius: "6px",
                border: "1px solid #D1D1D1",
                marginBottom: "32px"
              }}>
              <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
                <SelectInput
                  label={t("label_pesticide_name") + " " + (i + 1)}
                  required={true}
                  name={`list_pesticide.${i}.pesticide_id`}
                  editable={!isReadOnly}
                  placeholder={t("placeholder_choose_one")}
                  options={pesticideList}
                  withoutFeedback={false}
                  clearNow={true}
                  value={formValues["list_pesticide"][i]?.pesticide_id}
                  isLoading={General.loadingComponent}
                />
                <div className={"color-red"}>
                  {touched[`list_pesticide.${i}.pesticide_id`] &&
                    errors?.list_pesticide?.length &&
                    errors?.list_pesticide[i]?.pesticide_id &&
                    errors?.list_pesticide[i]?.pesticide_id}
                </div>
              </RowModule>
              <RowModule customColumnCss="mb-5 col-lg-12 col-sm-12 col-md-12">
                <TextInput
                  editable={!isReadOnly}
                  required={true}
                  label={t("label_dose_total")}
                  name={`list_pesticide.${i}.total_dose`}
                  placeholder={t("placeholder_input_dose_total")}
                  type={"text"}
                  value={formValues["list_pesticide"][i]?.total_dose ?? ""}
                />
                <div className={"color-red"}>
                  {touched?.list_pesticide?.length &&
                    touched?.list_pesticide[i]?.total_dose &&
                    errors?.list_pesticide?.length &&
                    errors?.list_pesticide[i]?.total_dose &&
                    errors?.list_pesticide[i]?.total_dose}
                </div>
              </RowModule>
              <div className={"d-flex justify-content-end"}>
                <Button
                  variant={"link"}
                  disabled={i === 0 && countPesticide === 1 ? true : false}
                  onClick={() => handleRemovePesticide(i)}
                  className={`flex align-items-center text-decoration-none`}>
                  <img src={ICON_CONSTANTS.REMOVE} alt="remove" />
                  <span className={"color-red ml-4 capitalize"}>{t("button_delete")}</span>
                </Button>
              </div>
            </div>
          ))}
          <div className={"d-flex justify-content-end align-items-center"}>
            <div
              onClick={() => handleAddPesticide()}
              className="cursor-pointer d-flex align-items-center">
              <SVG
                width={14}
                height={14}
                src={toAbsoluteUrl(ICON_CONSTANTS.PLUS)}
                className="mr-4"
              />
              <span className={"text-secondary-blue underline"} style={{ fontSize: "14px" }}>
                {t("button_add")} Pestisida
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  )
}
